import React, { useEffect, useState } from "react";
import "../styles/VocabularyComponent.css";

const VocabularyComponent = ({ voc }) => {
  const { vocabularies, currentIndex, nextWord, prevWord } =
    voc;

  if (vocabularies.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div className="vocabulary-container">
      <div className="button-container">
        <button onClick={prevWord} className="button">
          {"←"}
        </button>
        <div className="vocabulary-details">
          <label className="label" id="labelForVocabulary">
            {`順:${currentIndex} / ${vocabularies.length}`}
          </label>
        </div>
        <button onClick={nextWord} className="button">
          {"→"}
        </button>
      </div>
    </div>
  );
};

export default VocabularyComponent;
